// extracted by mini-css-extract-plugin
export default {"card":"packageCard_card__QTdDJ","cardHeader":"packageCard_cardHeader__xh3Is","tableHeader":"packageCard_tableHeader__18ZmM","tableDataRow":"packageCard_tableDataRow__N6kdH"};